const path = require('path')

const router = require('../../router')


module.exports = async(graphql, actions, route) => {
  const { createPage } = actions
  const notFoundContainer = path.resolve('src/containers/NotFound/index.js')

  return createPage({
    path: router(route.path),
    component: notFoundContainer,
    context: {},
  })
}
